import { Box, Flex, Icon } from "@chakra-ui/react";

const SwitchIcon = ({ size = "20px", color = "#000000", ...props }) => {
  return (
    <Icon width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7499 7.14648L18.6035 11H5.39648V10H16.1893L14.0428 7.85359L14.7499 7.14648Z"
          fill="#888888"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.25021 16.8535L5.39665 13L18.6034 13L18.6034 14L7.81087 14L9.95732 16.1464L9.25021 16.8535Z"
          fill="#888888"
        />
      </svg>
    </Icon>
  );
};
export default SwitchIcon;
